import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { ArrowRight, Workflow, Bot, Mail, Video, MessageSquare } from 'lucide-react';

export const CustomWorkflow = () => {
  const { t } = useTranslation();
  
  const features = [
    { icon: Workflow },
    { icon: Bot },
    { icon: Mail },
    { icon: Video },
    { icon: MessageSquare }
  ];

  const workflowFeatures = t('customWorkflow.features', { returnObjects: true });
  if (!Array.isArray(workflowFeatures)) return null;

  React.useEffect(() => {
    // Load Calendly widget script
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <section className="section py-24 overflow-hidden">
      <div className="grid lg:grid-cols-2 gap-12 items-start">
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="space-y-8"
        >
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold">
            {t('customWorkflow.title')}
          </h2>
          
          <p className="text-xl text-gray-600 dark:text-gray-300">
            {t('customWorkflow.description')}
          </p>

          <div className="space-y-6">
            {workflowFeatures.map((feature, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="flex items-start gap-4"
              >
                <div className="flex-shrink-0 w-10 h-10 rounded-xl bg-gray-100/40 dark:bg-black flex items-center justify-center">
                  {React.createElement(features[index].icon, { 
                    size: 20,
                    className: "stroke-[var(--gradient-start)]"
                  })}
                </div>
                <div className="flex-grow">
                  <p className="text-lg text-gray-700 dark:text-gray-200">
                    {feature}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="relative min-h-[700px] w-full bg-white dark:bg-[#131314] rounded-2xl shadow-xl border border-gray-100 dark:border-gray-700/50 overflow-hidden"
        >
          <div 
            className="calendly-inline-widget w-full h-[700px]" 
            data-url="https://calendly.com/alex-craft-with-ai/demo-de-craftseo"
          />
        </motion.div>
      </div>
    </section>
  );
};